import { render, staticRenderFns } from "./myFavor.vue?vue&type=template&id=e1c90de6&scoped=true"
import script from "./myFavor.vue?vue&type=script&lang=js"
export * from "./myFavor.vue?vue&type=script&lang=js"
import style0 from "./myFavor.vue?vue&type=style&index=0&id=e1c90de6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c90de6",
  null
  
)

export default component.exports